import { Section, SectionParagraph, SectionTitle } from '@/components/shared/Content';
import forbes from '@/static/assets/reviews/experts/forbes.svg';
import fortune from '@/static/assets/reviews/experts/fortune.svg';
import inc from '@/static/assets/reviews/experts/inc.svg';
import techCrunch from '@/static/assets/reviews/experts/techCrunch.svg';
import theEconomist from '@/static/assets/reviews/experts/theEconomist.svg';
import americaBestInsurance from '@/static/assets/reviews/experts/americaBestInsurance.svg';
import usNews from '@/static/assets/reviews/experts/usNews.svg';
import ventureBeat from '@/static/assets/reviews/experts/ventureBeat.svg';
import wallStreet from '@/static/assets/reviews/experts/wallStreet.svg';
import financialTimes from '@/static/assets/reviews/experts/financialTimes.svg';
import styled from 'styled-components';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { Flex } from '@lemonade-hq/cdk';
import { Slide, ImageSlider } from '@/common/Slider';

const DEFAULT_EXPERTS = [
  {
    name: 'Forbes',
    text: 'Lemonade is the top pick for renters insurance.',
    src: forbes,
  },
  {
    name: 'Fortune',
    text: 'Lemonade is the top pick for renters insurance.',
    src: fortune,
  },
  {
    name: 'Inc.',
    text: 'Lemonade is the top pick for renters insurance.',
    src: inc,
  },
  {
    name: 'TechCrunch',
    text: 'Lemonade is the top pick for renters insurance.',
    src: techCrunch,
  },
  {
    name: 'The Economist',
    text: 'Lemonade is the top pick for renters insurance.',
    src: theEconomist,
  },
  {
    name: "America's Best Insurance",
    text: 'Lemonade is the top pick for renters insurance.',
    src: americaBestInsurance,
  },
  {
    name: 'US News',
    text: 'Lemonade is the top pick for renters insurance.',
    src: usNews,
  },
  {
    name: 'VentureBeat',
    text: 'Lemonade is the top pick for renters insurance.',
    src: ventureBeat,
  },
  {
    name: 'Wall Street Journal',
    text: 'Lemonade is the top pick for renters insurance.',
    src: wallStreet,
  },
  {
    name: 'Financial Times',
    text: 'Lemonade is the top pick for renters insurance.',
    src: financialTimes,
  },
];

const StyledSubtitle = styled(SectionParagraph)`
  max-width: 516px;
`;

export interface ExpertsProps {
  experts?: Slide[];
  title: string;
  subtitle: string;
}

const Wrapper = styled(Flex)`
  ${MEDIA_QUERIES.mobile`
    gap: 48px;
  `}
`;

export const Experts = ({ experts = DEFAULT_EXPERTS, title, subtitle }: ExpertsProps) => {
  return (
    <Section pt={[48, 96]} pb={[48, 96]}>
      <Wrapper width="100%" alignItems="center" gap="72px" flexDirection="column">
        <Flex flexDirection="column" gap="12px">
          <SectionTitle>{title}</SectionTitle>
          <StyledSubtitle>{subtitle}</StyledSubtitle>
        </Flex>
        <ImageSlider slides={experts} />
      </Wrapper>
    </Section>
  );
};
